const brandArray = [
  // {
  //   logo: '/images/pages/home/brands/logos/adidas_logo.svg',
  //   background: '/images/pages/home/brands/backgrounds/adidas',
  //   alt: 'adidas',
  // },
  // {
  //   logo: '/images/pages/home/brands/logos/wca_logo.svg',
  //   background: '/images/pages/home/brands/backgrounds/wc_a',
  //   alt: 'wca',
  // },
  {
    logo: '/images/pages/home/brands/logos/revolve.svg',
    background: '/images/pages/home/brands/backgrounds/revolve',
    alt: 'revolve',
  },
  // {
  //   logo: '/images/pages/home/brands/logos/hyperloop.svg',
  //   background: '/images/pages/home/brands/backgrounds/hyperloop',
  //   alt: 'Virgin Hyperloop',
  // },
  {
    logo: '/images/pages/home/brands/logos/fashionphile.svg',
    background: '/images/pages/home/brands/backgrounds/fashionphile',
    alt: 'jbrand',
  },
  // {
  //   logo: '/images/pages/home/brands/logos/spotify_logo.svg',
  //   background: '/images/pages/home/brands/backgrounds/spotify',
  //   alt: 'spotify',
  // },
  // {
  //   logo: '/images/pages/home/brands/logos/zappos_logo.svg',
  //   background: '/images/pages/home/brands/backgrounds/zappos',
  //   alt: 'zappos',
  // },
  {
    logo: '/images/pages/home/brands/logos/gt_logo.svg',
    background: '/images/pages/home/brands/backgrounds/GT',
    alt: 'gt',
  },
  {
    logo: '/images/pages/home/brands/logos/midfirst_logo.svg',
    background: '/images/pages/home/brands/backgrounds/midfirst_bank',
    alt: 'midfirst',
  },
  {
    logo: '/images/pages/home/brands/logos/spaces_logo.svg',
    background: '/images/pages/home/brands/backgrounds/spaces',
    alt: 'spaces',
  },
  {
    logo: '/images/pages/home/brands/logos/joybird.svg',
    background: '/images/pages/home/brands/backgrounds/joybird',
    alt: 'joybird',
  },
  {
    logo: '/images/pages/home/brands/logos/conde_nast.svg',
    background: '/images/pages/home/brands/backgrounds/conde_nast',
    alt: 'conde nast',
  },
  {
    logo: '/images/pages/home/brands/logos/majordomo.svg',
    background: '/images/pages/home/brands/backgrounds/majordomo',
    alt: 'majordomo media',
  },
  // {
  //   logo: '/images/pages/home/brands/logos/apl.svg',
  //   background: '/images/pages/home/brands/backgrounds/apl',
  //   alt: 'apl',
  // },
  {
    logo: '/images/pages/home/brands/logos/day_one_agency.svg',
    background: '/images/pages/home/brands/backgrounds/day_one_agency',
    alt: 'day one agency',
  },
];

const keyFacts = [
  '3,200 - 400,000 SF of flexible space and 3,200 - 65,000 SF of pre-built spaces',
  'Tenant controlled air and filters (MERV 13 optional); Efficient VRF systems and outdoor air filtering through the space',
  '4 stalls per 1,000 SF parking in a 4,000 stall parking structure',
  'Adjacent to future Arts District South Metro Station',
  'Shuttles to and from Union Station and 7th Street Metro stop',
  'Metro Bike and indoor bike room',
  '24/7 on-site security',
  'Athletic club with wellness programs and personal training',
  '7 restaurants and 35 retailers',
  'Private event spaces and onsite event marketing concierges',
  'Secure and lush, landscaped  outdoor space and expansive rooftop spaces, all disinfected daily with electrostatic misting machines',
  'Dog-friendly district and buildings',
];

const pressLogos = [
  {
    logo: '/images/pages/home/press/bisnow.svg',
    alt: 'Bisnow',
    href: 'https://www.bisnow.com/los-angeles/news/deal-sheet/the-la-deal-sheet-98504',
  },
  {
    logo: '/images/pages/home/press/blackbook.svg',
    alt: 'Blackbook',
    href:
      'https://bbook.com/news/downtown-los-angeles-renaissance-our-favorite-stops-at-the-row-dtla/',
  },
  {
    logo: '/images/pages/home/press/bloomberg.svg',
    alt: 'Bloomberg',
    href:
      'https://www.bnnbloomberg.ca/shopify-to-open-first-bricks-and-mortar-location-in-l-a-1.1114516',
  },
  {
    logo: '/images/pages/home/press/cn_traveler.svg',
    alt: 'CN Traveler',
    href: 'https://www.cntraveler.com/shops/los-angeles/row-dtla',
  },
  {
    logo: '/images/pages/home/press/curbed.svg',
    alt: 'Curbed',
    href:
      'https://la.curbed.com/2016/1/12/10847514/arts-districts-alameda-square-factories-to-be-reborn-as-massive-mixed',
  },
  {
    logo: '/images/pages/home/press/eat_drink_la.svg',
    alt: 'Eat Drink LA',
    href: 'https://www.eatdrinkla.com/food-meets-fashion-at-row-dtla/',
  },
  {
    logo: '/images/pages/home/press/food_and_wine.svg',
    alt: 'Food & Wine',
    href: 'https://www.foodandwine.com/news/row-dtla-opens-los-angeles',
  },
  {
    logo: '/images/pages/home/press/goop.svg',
    alt: 'Goop',
    href: 'https://goop.com/place/california/los-angeles/downtown-shops/row-dtla/',
  },
  {
    logo: '/images/pages/home/press/jetsetter.svg',
    alt: 'Jet Setter',
    href: 'https://www.jetsetter.com/magazine/youre-not-a-tourist-los-angeles/#row-dtla',
  },
  {
    logo: '/images/pages/home/press/la_business_journal.svg',
    alt: 'La Business Journal',
    href: 'https://rowdtla.com/news/ghost-management-group-signs-115k-sf-arts-district-lease',
  },
  {
    logo: '/images/pages/home/press/la_mag.svg',
    alt: 'LA Magazine',
    href: 'https://www.lamag.com/sponsored/experience-a-taste-of-everything-row-dtla/',
  },
  {
    logo: '/images/pages/home/press/la_times.svg',
    alt: 'LA Times',
    href: 'https://www.latimes.com/home/la-hm-four-hours-row-dtla-20190607-story.html',
  },
  {
    logo: '/images/pages/home/press/mann_publications.svg',
    alt: 'Mann Publications',
    href:
      'http://www.mannpublications.com/mannreportresidential/2019/05/08/la-lifestyles-row-dtla/',
  },
  {
    logo: '/images/pages/home/press/monocle.svg',
    alt: 'Monocle',
    href: 'https://monocle.com/magazine/issues/123/top-of-the-shops/',
  },
  {
    logo: '/images/pages/home/press/thrillist.svg',
    alt: 'Thrillist',
    href: 'https://www.thrillist.com/travel/nation/best-attractions-usa-2019',
  },
  {
    logo: '/images/pages/home/press/urbanize_la.svg',
    alt: 'Urbanize LA',
    href: 'https://rowdtla.com/news/this-weeks-leases-zappos-takes-space-at-row-dtla',
  },
];

export { brandArray, keyFacts, pressLogos };
